/** @format */

import React from "react";

//material ui
import { Box } from "@mui/material";

//components
import HeroSection from "../components/AboutUs/HeroSection";
import Motivation from "../components/AboutUs/Motivation";
import Members from "../components/AboutUs/Members";

const useStyles = () => ({
	container: {
		width: "100%",
		minHeight: "100vh",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		textAlign: "center",
		overflow: "hidden",
	},
});

const JavaScriptBootcamp = () => {
	const classes = useStyles();

	return (
		<>
			<Box sx={classes.container}>
				<HeroSection />
				<Motivation />
				<Members />
			</Box>
		</>
	);
};

export default JavaScriptBootcamp;
